export default __webpack_public_path__ + "static/media/light-bulb.11b16de4.svg";